import { render, staticRenderFns } from "./screenManagement.vue?vue&type=template&id=695abad2&scoped=true"
import script from "./screenManagement.vue?vue&type=script&lang=js"
export * from "./screenManagement.vue?vue&type=script&lang=js"
import style0 from "./screenManagement.vue?vue&type=style&index=0&id=695abad2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695abad2",
  null
  
)

export default component.exports